export default __webpack_public_path__ + "static/media/menu-logo-dark.b473c957.png";